
export const projectsData = [
    {
        id: 1,
        projectName: 'Meesho',
        projectDesc: 'Meesho is an Ecommerce platform where user can search from a wide variety of products and place orders smoothly without any hassle',
        tags: ["React", "Node.js", "MongoDb"],
         logos: ["fab fa-react", "fab fa-css3", "fab fa-js"],
        code: 'https://github.com/Harsh-R-16/Meesho-Clone',
        demo: 'https://meesho-website-clone.netlify.app/',
        image: "https://i.imgur.com/XfrAOt0.png"
    },
    {
        id: 2,
        projectName: 'Meetup',
        projectDesc: 'Meetup Music is a event organizing website where you ca create an joins groups that excites you.',
        tags: ["React", "Node.js", "MongoDb"],
         logos: ["fab fa-react", "fab fa-css3", "fab fa-js"],
        code: 'https://github.com/ayush-code-drops/MeetUp-Clone',
        demo: 'https://meet-up-clone.netlify.app/',
        image: "https://user-images.githubusercontent.com/65801101/160452864-a61732ed-7be3-4b2f-aeb5-3e0a3fef183f.png"
    },
    {
        id: 3,
        projectName: 'Fresly',
        projectDesc: 'Fresly is a meal delivery service where user can order meals online. It is built by usig advanced Js concepts along with Json-server and Api binding',
        tags: ["React", "Express.js", "Node.js", "Bootstrap",],
        logos: ["fab fa-js", "fab fa-bootstrap","fab fa-html5"],
        code: 'https://github.com/ayush-code-drops/Freshly-Meal-Delivery-Service',
        demo: 'https://jovial-banach-4121a8.netlify.app/index.html',
        image: "https://user-images.githubusercontent.com/75352182/146799583-a847f3a1-e116-40c4-a648-6cdc3ac5b001.png"
    },
    {
        id: 4,
        projectName: 'LeadiQ',
        projectDesc: 'LeadIQ eliminates the most annoying parts of prospecting, helping sales reps get new deals with less work.',
        tags: ["Html", "css", "javascript"],
         logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
        code: 'https://github.com/rajachoudhary/Cobalt',
        demo: 'https://elastic-yalow-d2797d.netlify.app',
        image: "https://i.ibb.co/jwKPWK2/Screenshot-229.png"
    },
    
]




//schema for entwreing data
/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/